import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Note } from 'src/app/services/notes.service';

export interface NoteDetailDialogData {
  note: Note;
}

@Component({
  selector: 'app-note-detail-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="note-dialog" [style.backgroundColor]="data.note.color || '#ffffff'">
      <header class="note-dialog-header">
        <div class="note-dialog-title">
          <mat-icon class="note-icon">sticky_note_2</mat-icon>
          <span>{{ data.note.title || 'Untitled note' }}</span>
        </div>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <div class="note-dialog-content">
        <pre>{{ data.note.content }}</pre>
      </div>

      <footer class="note-dialog-footer">
        <button mat-stroked-button (click)="close()">
          Close
        </button>
      </footer>
    </div>
  `,
  styles: [`
    .note-dialog {
      padding: 1rem 1.25rem 1rem;
      border-radius: 1rem;
      min-height: 0;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
      box-shadow: 0 18px 45px rgba(15, 23, 42, 0.6);
    }

    .note-dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5rem;
    }

    .note-dialog-title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: 600;
      font-size: 1rem;
      color: #020617;
    }

    .note-icon {
      color: rgba(55, 65, 81, 0.9);
    }

    .note-dialog-content {
      flex: 1;
      overflow: auto;
      margin: 0.5rem 0 0.75rem;
      padding: 0.75rem;
      background: rgba(255, 255, 255, 0.7);
      border-radius: 0.75rem;
      border: 1px solid rgba(148, 163, 184, 0.5);
    }

    .note-dialog-content pre {
      margin: 0;
      font-family: "Montserrat", sans-serif;
      font-size: 0.9rem;
      white-space: pre-wrap;
      color: #111827;
    }

    .note-dialog-footer {
      display: flex;
      justify-content: flex-end;
    }
  `]
})
export class NoteDetailDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: NoteDetailDialogData,
    private dialogRef: MatDialogRef<NoteDetailDialogComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
